// Guards against the unauthenticated catch-all route (App.js) re-stashing
// `location.state.from` if it renders once more with the pre-logout URL
// before the router settles on /login. Not Redux state: `auth/logOut`
// resets the entire store tree, which would wipe a flag stored there.
let explicitLogout = false;

export const markExplicitLogout = () => {
	explicitLogout = true;
};

export const peekExplicitLogout = () => explicitLogout;

export const clearExplicitLogout = () => {
	explicitLogout = false;
};

// Used as the `from` location on logout so the next login always lands on
// /home instead of the page the user logged out from.
export const HOME_FROM_LOCATION = { pathname: "/home", search: "", hash: "" };
